import { useQuery } from '@tanstack/react-query';

import { api } from '../../services/api';

export type PartnerNameSuggestionsResponse = {
  partnerNames: string[];
};

export const partnerNameSuggestionKeys = {
  all: ['partner-name-suggestions'] as const,
};

export function usePartnerNameSuggestions(enabled: boolean) {
  return useQuery<PartnerNameSuggestionsResponse, Error>({
    queryKey: partnerNameSuggestionKeys.all,
    queryFn: () =>
      api.get<PartnerNameSuggestionsResponse>(
        '/requests/partner-name-suggestions',
      ),
    enabled,
    retry: false,
  });
}
